export default [
  {
    title: `Offline First Mobile App`,
    description: `Don't depend on Connectivity. Being Offline Enabled ensures you'll capture every detail in the field.`,
    icon: 'offlineFirst'
  },
  {
    title: `Task Management`,
    description: `Organizing and completing tasks is intuitive and effective for any type of service.`,
    icon: 'taskManagement'
  },
  {
    title: `Clocking Team Shifts`,
    description: `Gain unprecedented visibility in to Team Performance while tracking Payroll with Task Completion Times, Clock Ins, Clock Outs and more.`,
    icon: 'teamShifts'
  },
  {
    title: `Support in Real Time`,
    description: `Locked out of the building? Need a Supervisor? Your Team Lead's contact information is visible on the Job for effortless communication.`,
    icon: 'realtimeSupport'
  }
]
